import { UsersRepository } from '@User/Data/Repository/UsersRepository'
import {
    CreateUserUseCase,
    GetUsersUseCase,
    GetUserUseCase,
    UpdateUserUseCase,
} from '@User/Domain/UseCases'
import { Container } from 'inversify'
import { UserAPI } from '../API/UserAPI'
import { Register } from './UserRegister'
import { DisableUserUseCase } from '@User/Domain/UseCases/DisableUser'
import { EnableUserUseCase } from '@User/Domain/UseCases/EnableUser'

const container = new Container()
container
    .bind<CreateUserUseCase>(Register.UseCaseCreateUser)
    .toDynamicValue(
        () => new CreateUserUseCase(new UsersRepository(new UserAPI()))
    )
container
    .bind<GetUserUseCase>(Register.UseCaseGetUser)
    .toDynamicValue(
        () => new GetUserUseCase(new UsersRepository(new UserAPI()))
    )
container
    .bind<GetUsersUseCase>(Register.UseCaseGetUsers)
    .toDynamicValue(
        () => new GetUsersUseCase(new UsersRepository(new UserAPI()))
    )
container
    .bind<UpdateUserUseCase>(Register.UseCaseUpdateUser)
    .toDynamicValue(
        () => new UpdateUserUseCase(new UsersRepository(new UserAPI()))
    )

container
    .bind<DisableUserUseCase>(Register.UseCaseDisableUser)
    .toDynamicValue(
        () => new DisableUserUseCase(new UsersRepository(new UserAPI()))
    )

container
    .bind<EnableUserUseCase>(Register.UseCaseEnableUser)
    .toDynamicValue(
        () => new EnableUserUseCase(new UsersRepository(new UserAPI()))
    )

export default container
